export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.3.27-1421.30',
  commitId: '4bcd871dcb00adc757e955874bc7fef3fd48b6a5',
  commitTime: '2026-03-27T14:21:30.000Z',
});
